import { createFileRoute } from '@tanstack/react-router'

import { PaginaAlertasTimes } from '@/features/alertas-times/pagina'

export const Route = createFileRoute('/$perfil/alertas')({
  component: Tela,
})

function Tela() {
  return <PaginaAlertasTimes />
}
